var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { downloadFile, previewFile } from "@madmedical/file";
import { useCallback, useState } from "react";
import useShowToast from "../atoms/useShowToast";
export default () => {
    const showToast = useShowToast();
    const [isDownloading, setDownloading] = useState(false);
    const preview = useCallback(({ previewUrl, filename, mimeType }) => __awaiter(void 0, void 0, void 0, function* () {
        setDownloading(true);
        try {
            yield previewFile(previewUrl, filename, mimeType);
        }
        catch (_a) {
            showToast("Nem támogatott fájl típus.", { variant: "error" });
        }
        finally {
            setDownloading(false);
        }
    }), [showToast]);
    const download = useCallback(({ downloadUrl, filename, mimeType }) => __awaiter(void 0, void 0, void 0, function* () {
        setDownloading(true);
        try {
            yield downloadFile(downloadUrl, filename, mimeType);
        }
        catch (_b) {
            showToast("Sikertelen letöltés.", { variant: "error" });
        }
        finally {
            setDownloading(false);
            showToast("A letöltés befejeződött.", { variant: "success" });
        }
    }), [showToast]);
    return { preview, download, isDownloading };
};
